import React, { useEffect } from "react";
import SelectComp from '../../NewComponent/Select/Select';
import { useSelector } from "react-redux";

export default function ExpDropdown({expert,rerouteUser, category, updateCategory}) {
    const [expertt, setExpert] = React.useState(expert.expertName);
    const onChangeDropdown= (value) => {
        expert.expert = value;
        expert.active = false;
        expert.expertName = value;
        setExpert(value);
        category.filter(cat => {
            if(cat.firstName + ' ' + cat.lastName === expert.expertName) {
                expert.filterByExperts = [cat];
            }
            return expert;
        }
        );
        console.log(expert);
    // updateCategory(updatedCat);
  };
  useEffect(() => {
    expert.expert = null
  }, []);   
  return (
    <>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <div key={expert.domainName} style={{ padding: "10px" }}>
          <div
            style={{ fontWeight: "300", color: "#5C667B", fontSize: "15px" }}
          >
            {expert.domainName}&nbsp;
          </div>
        </div>
        <div>
          <SelectComp
            onChangeFunc={onChangeDropdown}
            placeholder="Select Expert"
            isString={false}
            val={expertt}
            options={rerouteUser}
            width={"220px"}
            size={"large"}
          />
        </div>
      </div>
    </>
  );
}
